import { render, staticRenderFns } from "./CollectorData.vue?vue&type=template&id=3ffbe382&scoped=true&"
import script from "./CollectorData.vue?vue&type=script&lang=js&"
export * from "./CollectorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbe382",
  null
  
)

export default component.exports